import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { Badge } from "@mui/material";
import { makeStyles } from "@mui/styles";
import Switch from "../../ui/CustomSwitch";
import { useTheme } from "../../contexts/ThemeContext";
import { useSidebar } from "../../contexts/SidebarContext";
import {
  SidebarItemContainer,
  IconContainer,
  Icon,
  SidebarItemText,
  IconWrapper,
  SubMenuContainer,
} from "../../styled-components/Sidebar.Styles";
import { ISidebarListItem } from "../../types/ISidebarListItem";
import { useClubSearch } from "../../contexts/ClubSearchContext";
import { useNotification } from "../../contexts/NotificationContext";
import { useSearch } from "../../contexts/PlayerSearchContext";

const useBadgeStyles = makeStyles((theme) => ({
  badgeGrey: {
    backgroundColor: "#7C8084",
    fontfamily: "DM Mono",
  },
  badgeOrange: {
    backgroundColor: "#FF3864",
    fontfamily: "DM Mono",
    marginRight: "8px",
    justifyContent: "center",
  },
}));

const SidebarListItem: React.FC<ISidebarListItem> = ({
  Id,
  icon,
  text,
  path,
  updates,
  submenu,
  isActive,
  onClick,
  ParentId,
  toggleSidebar,
  shouldNavigate,
  subNav,
}) => {
  const { hideNotification, setDisplayNotification } = useNotification();
  const { isOpen, toggleSubSidebar, subMenuOpen, setActiveItemId, toggleDrawer, drawerState, isBlurred, setIsBlurred ,homeGlobalSearch , setIsHomeGloablSearch } = useSidebar();
  const { setAttributesDrawerOpen, setTagsDrawerOpen } = useSearch();
  const { setClubSearchData } = useClubSearch();
  const { toggleTheme } = useTheme();
  const navigate = useNavigate();
  const classes = useBadgeStyles(); // Apply custom styles
  const theme = localStorage.getItem("theme");
  const [isToggled, setIsToggled] = useState<boolean>(theme === "light" ? false : true);

  const handleClick = (event: React.MouseEvent<HTMLLIElement, MouseEvent>) => {
    hideNotification();
    setDisplayNotification(false);
    setClubSearchData?.([]);
    const target = event.target as HTMLElement;
    if (target.tagName.toLowerCase() === "input") {
      return;
    }

    if (submenu && submenu.length > 0) {
      toggleSubSidebar?.(!subMenuOpen);
      toggleDrawer?.(false);
    } else if (subNav) {
      if (text === "Players") {
        // toggleDrawer?.(true, "player");
        setAttributesDrawerOpen(false);
        setTagsDrawerOpen(false);
      } else if (text === "Create club list") {
        // toggleDrawer?.(true, "club");
      } else if (text === "Search") {
        toggleDrawer?.(true, "search");
      }
    } else {
      setActiveItemId?.(Id);
      toggleDrawer?.(false);
      setIsBlurred!(true);
      setTimeout(() => setIsBlurred!(false), 2700);
      navigate(path, { state: { fromMenu: true } });
    }

    if (submenu?.length === 0) {
      navigate(path, { state: { fromMenu: true } });
    }

    if (ParentId !== undefined) {
      onClick?.(ParentId);
    } else {
      onClick?.(Id);
    }
  };

  const handleSwitchClick = (event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
    event.stopPropagation();
    setIsToggled(!isToggled);
    toggleTheme();
  };

  const renderIconWithBadge = () => (
    <IconWrapper>
      <IconContainer hover={!!isOpen}>
        {updates !== undefined && updates >= 0 ? (
          <Badge badgeContent={updates} showZero classes={{ badge: updates === 0 ? classes.badgeGrey : classes.badgeOrange }}>
            <Icon icon={icon} isActive={isActive} />
          </Badge>
        ) : text === "Light mode" ? (
          <Switch id="test-switch" toggled={isToggled} onChange={handleSwitchClick} source="Sidebar" isByComparison={false} />
        ) : (
          <Icon icon={icon} isActive={isActive} />
        )}
      </IconContainer>
    </IconWrapper>
  );

  const renderMainContent = () => (
    <>
      {renderIconWithBadge()}
      {isOpen && <SidebarItemText isOpen={isOpen}>{isToggled && text === "Light mode" ? "Dark mode" : text}</SidebarItemText>}
    </>
  );

  return (
    <>
      <SidebarItemContainer isActiveMenu={isActive} onClick={handleClick} onMouseEnter={() => toggleSidebar && toggleSidebar(true)}>
        {shouldNavigate ? (
          <Link to={path} className="sidebar-link">
            {renderMainContent()}
          </Link>
        ) : (
          renderMainContent()
        )}
      </SidebarItemContainer>
      {submenu && isOpen && subMenuOpen && (
        <div className="user-submenu">
          <SubMenuContainer>
            {submenu.map((item, index) =>
              item.shouldNavigate ? (
                <Link to={item.path} key={index} style={{ textDecoration: "none", color: "inherit" }}>
                  <SidebarListItem
                    Id={item.Id}
                    key={index}
                    icon={item.icon}
                    text={item.text}
                    path={item.path}
                    updates={item.updates}
                    submenu={item.submenu}
                    ParentId={Id}
                    onClick={onClick}
                  />
                </Link>
              ) : (
                <SidebarListItem
                  Id={item.Id}
                  key={index}
                  icon={item.icon}
                  text={item.text}
                  path={item.path}
                  updates={item.updates}
                  submenu={item.submenu}
                  ParentId={Id}
                  onClick={onClick}
                />
              )
            )}
          </SubMenuContainer>
        </div>
      )}
    </>
  );
};

export default SidebarListItem;
